export const SEARCH_VISIBLE_COMPANY_COUNT = 10;
